/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_CompanySsoConfigurationDto } from '../models/PagedResultDto_CompanySsoConfigurationDto';
import type { Wealthlane_Dtos_SsoProvider_CompanySsoConfigurationDto } from '../models/Wealthlane_Dtos_SsoProvider_CompanySsoConfigurationDto';
import type { Wealthlane_Dtos_SsoProvider_CreateUpdateCompanySsoConfigurationDto } from '../models/Wealthlane_Dtos_SsoProvider_CreateUpdateCompanySsoConfigurationDto';
import type { Wealthlane_Dtos_SsoProvider_SsoConfigurationSetupInfoDto } from '../models/Wealthlane_Dtos_SsoProvider_SsoConfigurationSetupInfoDto';
import type { Wealthlane_Dtos_SsoProvider_UpdateSsoConfigurationSigningCertificateDto } from '../models/Wealthlane_Dtos_SsoProvider_UpdateSsoConfigurationSigningCertificateDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanySsoConfigurationService {

    /**
     * @param requestBody
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiIdentityApiAppCompanySsoConfiguration(
        requestBody?: Wealthlane_Dtos_SsoProvider_CreateUpdateCompanySsoConfigurationDto,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/app/company-sso-configuration',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter
     * @param isEnabled
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_CompanySsoConfigurationDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppCompanySsoConfiguration(
        filter?: string,
        isEnabled?: boolean,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_CompanySsoConfigurationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/company-sso-configuration',
            query: {
                'Filter': filter,
                'IsEnabled': isEnabled,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static putApiIdentityApiAppCompanySsoConfiguration(
        id: string,
        requestBody?: Wealthlane_Dtos_SsoProvider_CreateUpdateCompanySsoConfigurationDto,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/identity/api/app/company-sso-configuration/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static deleteApiIdentityApiAppCompanySsoConfiguration(
        id: string,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/identity/api/app/company-sso-configuration/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_Dtos_SsoProvider_CompanySsoConfigurationDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppCompanySsoConfiguration1(
        id: string,
    ): CancelablePromise<Wealthlane_Dtos_SsoProvider_CompanySsoConfigurationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/company-sso-configuration/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param isEnabled
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiIdentityApiAppCompanySsoConfigurationEnableDisableSsoConfiguration(
        id: string,
        isEnabled?: boolean,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/app/company-sso-configuration/{id}/enable-disable-sso-configuration',
            path: {
                'id': id,
            },
            query: {
                'isEnabled': isEnabled,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiIdentityApiAppCompanySsoConfigurationUpdateSigningCertificate(
        requestBody?: Wealthlane_Dtos_SsoProvider_UpdateSsoConfigurationSigningCertificateDto,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/app/company-sso-configuration/update-signing-certificate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_Dtos_SsoProvider_SsoConfigurationSetupInfoDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppCompanySsoConfigurationNewSsoSetupInfo(): CancelablePromise<Wealthlane_Dtos_SsoProvider_SsoConfigurationSetupInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/company-sso-configuration/new-sso-setup-info',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppCompanySsoConfigurationPptIdentifierTypes(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/company-sso-configuration/ppt-identifier-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppCompanySsoConfigurationProviderTypes(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/company-sso-configuration/provider-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
